import { gql } from '@apollo/client';

const DEVICE_FIELDS = `
  device_id
  device_name
  serial_number
  esper_device_id
  location_id
  location_name
  station_mode
  locked_role
  locked_at
  disabled_at
  reset_at
  reset_source
  lock_status
  shared_location_count
  created_at
  last_active_at
`;

export const QUERY_LIST_DEVICE = gql`
  query listDevice(
    $where: WhereDeviceInput
    $order: [OrderInput!]
    $pagination: PaginationInput
  ) {
    listDevice(where: $where, order: $order, pagination: $pagination) {
      list {
        ${DEVICE_FIELDS}
      }
    }
  }
`;

export const QUERY_TOTAL_DEVICE = gql`
  query totalDevice($where: WhereDeviceInput) {
    totalDevice(where: $where) {
      total
    }
  }
`;

export const MUTATION_RESET_DEVICE = gql`
  mutation resetDevice($device_id: String!) {
    resetDevice(device_id: $device_id) {
      ${DEVICE_FIELDS}
    }
  }
`;

export const MUTATION_SET_DEVICE_DISABLED = gql`
  mutation setDeviceDisabled($device_id: String!, $disabled: Boolean!) {
    setDeviceDisabled(device_id: $device_id, disabled: $disabled) {
      ${DEVICE_FIELDS}
    }
  }
`;
